module.exports = __webpack_public_path__ + "img/intellect-scene-4.0aed58bf.png";